module.exports = __webpack_public_path__ + "static/img/20190305.66ca1fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/chanpin/20190305.png
// module id = 27hi
// module chunks = 1